const pageSectionsMixin = {
	/**
	 * to work you must implement 'sections' object in the component's data() {return {}}
	 * EXAMPLE:
	 * 	data() {
	 * 		return {
	 *      sections: {
	 *        head: {id: 'head-section'},
	 *        video: {id: 'video-section'},
	 *        file: {id: 'file-section'},
	 *        faq: {id: 'faq-section'},
	 *        email: {id: 'email-section'},
	 *        survey: {id: 'survey-section'}
	 *			},
	 *		}
	 *	}
	 *
	 * Also, use this 'sections' object to apply the html ids.
	 * EXAMPLE: (check the ResourcePage)
	 * <section :id="sections.head.id" class="page-header-section resource-page-section tablet-no-padding">
	 *
	 *   !important
	 *   If you do not want to trigger the methods in mounted() immediately when the page is loaded then add: "this.startOnMounted = false;" in the beforeMount() of
	 *   your page - then invoke it manually where you want. This is used in the Homepage where this methods are invoked after the data is fetched from the BE
	 */
	data() {
		return {
			startOnMounted: true
		}
	},
	mounted() {
		if (this.startOnMounted) {
			let observer = this.observeSectionVisibility();
			this.attachObserverToAllSections(observer);
			this.autoScrollToSectionOnPageLoad();
		}
	},
	methods: {
		observeSectionVisibility() {
			return new IntersectionObserver(
				(entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							history.replaceState(null, '', `#${entry.target.id}`);
						}
					});
				},
				{ threshold: 0.6 }
			);
		},
		attachObserverToAllSections(observer) {
			this.$nextTick(() => {
				Object.entries(this.sections).forEach(([key, value]) => {
					const el = document.getElementById(value.id);
					if (el) observer.observe(el);
				});
			})
		},
		autoScrollToSectionOnPageLoad() {
			this.$nextTick(() => {
				const hash = window.location.hash;
				if (hash) {
					const targetEl = document.querySelector(hash);
					if (targetEl) {
						targetEl.scrollIntoView({ behavior: 'smooth' });
					}
				}
			});
		}
	}
}

export default pageSectionsMixin;

